import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import {
  GenericComponentsModule,
  ResizeHandleModule,
} from '@helios/generic-components'
import { WorkbenchGridModule } from './components/workbench-grid/workbench-grid.module'
import { Transactions2PanelComponent } from './transactions-2-panel.component'

@NgModule({
  imports: [
    CommonModule,
    GenericComponentsModule,
    ResizeHandleModule,
    WorkbenchGridModule,
  ],
  declarations: [Transactions2PanelComponent],
  exports: [Transactions2PanelComponent],
})
export class Transactions2Module {}

export { Transactions2PanelComponent }
